import { forwardRef, useId } from "react";
import type { TextareaHTMLAttributes } from "react";

import { cn } from "./utils";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  etiqueta: string;
  ayuda?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { etiqueta, ayuda, error, className, id, ...resto },
  ref,
) {
  const idGenerado = useId();
  const idCampo = id ?? idGenerado;
  const idAyuda = ayuda ? `${idCampo}-ayuda` : undefined;
  const idError = error ? `${idCampo}-error` : undefined;
  const describedBy = [idAyuda, idError].filter(Boolean).join(" ") || undefined;

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <label htmlFor={idCampo} className="text-etiqueta text-texto">
        {etiqueta}
      </label>
      <textarea
        ref={ref}
        id={idCampo}
        aria-describedby={describedBy}
        aria-invalid={Boolean(error) || undefined}
        className={cn(
          "min-h-24 rounded-control border border-borde bg-superficie p-3 text-cuerpo text-texto shadow-sm",
          "focus-visible:border-primario focus-visible:shadow-foco",
          "disabled:cursor-not-allowed disabled:bg-fondo disabled:text-texto-secundario/50",
          error && "border-peligro",
        )}
        {...resto}
      />
      {ayuda ? <p id={idAyuda} className="text-nota text-texto-secundario">{ayuda}</p> : null}
      {error ? <p id={idError} className="text-nota text-peligro" role="alert">{error}</p> : null}
    </div>
  );
});
